module.exports = __webpack_public_path__ + "static/img/card_1_1.7f1aabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_1_1.png
// module id = ITIj
// module chunks = 0